import React, { Component } from 'react'
import Select from 'react-select'
import moment from 'lib/moment-timezone-custom'

export default class RoomWeekSelect extends Component {
  constructor (props) {
    super(props)
    this.state = {
      datesAsOptions: []
    }

    const weeksCountToShow = 10

    for (var i = 1; i <= weeksCountToShow; i++) {
      var start = moment()
        .add(i * 7 - 7, 'days')
        .startOf('day')
      var end = moment()
        .add(i * 7 - 1, 'days')
        .endOf('day')
      this.state.datesAsOptions.push({
        label: start.format('D') + ' - ' + end.format('D MMMM'),
        value: start
      })

      if (props.selected && start <= props.selected && props.selected < end) {
        this.state.placeholder = start.format('D') + ' - ' + end.format('D MMMM')
      }
    }
  }

  componentDidMount () {
    this.updatePlaceholder(this.props)
  }

  // TODO:
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.updatePlaceholder(nextProps)
    }
  }

  updatePlaceholder (props) {
    var index = this.state.datesAsOptions.findIndex(function (option) {
      return props.selected >= option.value && props.selected <= moment(option.value).day(6)
    })

    if (index >= 0) {
      this.setState({ placeholder: this.state.datesAsOptions[index].label })
    } else {
      this.setState({ placeholder: '-' })
    }
  }

  onChange (option) {
    this.setState({ placeholder: option.label })
    this.props.onChange(option.value)
  }

  render () {
    return (
      <Select
        searchable={false}
        clearable={false}
        name="date-select"
        placeholder={this.state.placeholder}
        options={this.state.datesAsOptions}
        onChange={this.onChange.bind(this)}
      />
    )
  }
}
